import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'
import apiGet from 'lib/network/apiGet'
import ActivityLogs from 'pages/reports/ActivityLogs'
// Old per-car refund policies, replaced by the refund engine (bookings paid before go-live still use them).
// import LegacyRefundPolicies from './LegacyRefundPolicies'
import RefundRules from './RefundRules'
import RefundSettings from './RefundSettings'
import RefundsList from './RefundsList'
import RefundSimulator from './RefundSimulator'
import { useRefundSettings } from './refundShared'

const noop = () => {}
const TABS = ['refunds', 'rules', 'settings', 'simulator', 'audit']

/** Refund engine admin (Master Data → Refund Engine): approval queue, rules, settings, simulator and audit. */
const RefundPolicy = () => {
  const { t, i18n } = useTranslation()
  const isRTL = i18n.language === 'ar'
  const [settings, setSettings] = useRefundSettings()
  const [pendingCount, setPendingCount] = useState(0)
  const [tab, setTab] = useState('refunds')

  const fetchPendingCount = () => apiGet('refunds/pending-count').then(response => response?.success && setPendingCount(response.data?.count || 0))

  useEffect(() => {
    fetchPendingCount()
  }, [])

  return (
    <div>
      {/* Sub-tabs, same underline style as Master Data / Points of interest */}
      <div className="bg-white px-4 sm:px-6 lg:px-8 border-b border-gray-200 overflow-x-auto">
        <nav className={classNames('-mb-px flex', isRTL ? 'space-x-6 space-x-reverse' : 'space-x-6')} aria-label="Tabs">
          {TABS.map(key => (
            <button
              key={key}
              type="button"
              onClick={() => setTab(key)}
              aria-current={tab === key ? 'page' : undefined}
              className={classNames(
                tab === key ? 'border-indigo-500 text-indigo-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
                'inline-flex items-center gap-2 whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm'
              )}
            >
              {t(`refundEngine.tabs.${key}`)}
              {key === 'refunds' && pendingCount > 0 && (
                <span className="inline-flex items-center justify-center min-w-[20px] px-1.5 py-0.5 rounded-full bg-amber-100 text-amber-800 text-xs font-medium">
                  {pendingCount}
                </span>
              )}
            </button>
          ))}
          {/* legacy: <LegacyRefundPolicies /> */}
        </nav>
      </div>

      {tab === 'refunds' && <RefundsList onChanged={fetchPendingCount} />}
      {tab === 'rules' && <RefundRules settings={settings} />}
      {tab === 'settings' && settings && <RefundSettings key={settings.version} settings={settings} onSaved={setSettings} />}
      {tab === 'simulator' && <RefundSimulator settings={settings} />}
      {tab === 'audit' && <ActivityLogs apiQueryString={{ action: 'Refund' }} setDateRange={noop} setSearchKey={noop} setScanStatus={noop} />}
    </div>
  )
}

export default RefundPolicy
